// add component imports
import CertificatesPageComponent from "../components/CertificatesPageComponent";
import DownloadsPageComponent from "../components/DownloadsPageComponent";
import HomeComponent from "../components/HomeComponent";
import StructurePageComponent from "../components/StructurePageComponent";
import DirectionCommitteePageComponent from "../components/DirectionCommitteePageComponent";
import ExaminationCommitteePageComponent from "../components/ExaminationCommitteePageComponent";
import ATBsPageComponent from "../components/ATBsPageComponent";
import ContactPageComponent from "../components/ContactPageComponent";

const RouteNames = [
  {
    name: "/",
    component: <HomeComponent />,
    title: "home_tab",
  },
  {
    name: "/home",
    component: <HomeComponent />,
    title: "home_tab",
  },
  {
    name: "/certificari",
    component: <CertificatesPageComponent />,
    title: "certifications_tab",
  },
  {
    name: "/descarcari",
    component: <DownloadsPageComponent />,
    title: "downloads_tab",
  },
  {
    name: "/organizare",
    component: <StructurePageComponent />,
    title: "structure_tab",
  },
  {
    name: "/comitet-de-directie",
    component: <DirectionCommitteePageComponent />,
    title: "direction_committee_tab",
  },
  {
    name: "comisii-de-examinare",
    component: <ExaminationCommitteePageComponent />,
    title: "examination_committee_tab",
  },
  {
    name: "atbs",
    component: <ATBsPageComponent />,
    title: "ATBs",
  },
  {
    name: "/contacte",
    component: <ContactPageComponent />,
    title: "contacts_tab",
  },
];

export const ROOT = {
  name: "/",
  component: <HomeComponent />,
};

export const HOME = {
  name: "/",
  component: <HomeComponent />,
};

export const CERTIFICATES = {
  name: "/certificari",
  component: <CertificatesPageComponent />,
};

export const DOWNLOADS = {
  name: "/descarcari",
  component: <DownloadsPageComponent />,
};

export const STRUCTURE = {
  name: "/organizare",
  component: <StructurePageComponent />,
};

export const DIRECTION_COMMITTEE = {
  name: "/comitet-de-directie",
  component: <DirectionCommitteePageComponent />,
};

export const EXAMINATION_COMMITTEE = {
  name: "/comisii-de-examinare",
  component: <ExaminationCommitteePageComponent />,
};

export const ATBS = {
  name: "/atbs",
  component: <ATBsPageComponent />,
};

export const CONTACTS = {
  name: "/contacte",
  component: <ContactPageComponent />,
};

export default RouteNames;
